import { useSelector, useDispatch } from "react-redux";
import {
  fetchExamQuestionRequest,
  setActiveSection,
  setCurrentQuestionIndex,
} from "../../../../redux/exam/examSlice";
import "./SectionTabs.css";
import { useState, useMemo, useEffect, useRef } from "react";
import Sidebar from "../../../../shared/components/Sidebar/Sidebar";
import { getExamSectionKey } from "../../../../shared/utilities/helpers/examSectionKey";
import QuestionGrid from "./question/QuestionGrid/QuestionGrid";
import QuestionLegend from "./question/QuestionLegend/QuestionLegend";
import images from "../../../../utilities/images/images";
import { useLocation } from "react-router-dom";

// export default function SectionTabs({ isSidebarOpen, setIsSidebarOpen }) {
export default function SectionTabs({ onSelectQuestion }) {
  const location = useLocation();
  const { questionsData, activeSection, testDetails, paperId } = useSelector(
    (s) => s.examSlice
  );
  const isAdaptiveMode = location?.state?.useAdaptiveTestScreen === true;
  const dispatch = useDispatch();
  const [_, setActiveQuestionId] = useState(null);

  const sidebarWidth = 400;
  const questionRefs = useRef({});

  const handleSelectQuestionInternal = (id) => {
    setActiveQuestionId(id);
    if (typeof onSelectQuestion === "function") {
      onSelectQuestion(id);
    }
  };

  const combinedSections = useMemo(() => {
    const unique = new Set();
    questionsData.forEach((q) => {
      unique.add(getExamSectionKey(q));
    });
    return Array.from(unique);
  }, [questionsData]);

  // useEffect(() => {
  //   if (!activeSection && combinedSections.length > 0) {
  //     dispatch(setActiveSection(combinedSections[0]));
  //   }
  // }, [combinedSections, activeSection, dispatch]);

  useEffect(() => {
  if (!combinedSections.length) return;

  const currentQuestion = questionsData?.find(
    (q) => q.status === "current"
  );

  if (currentQuestion) {
    const section = getExamSectionKey(currentQuestion);

    dispatch(setActiveSection(section)); 
  } else if (!activeSection) {
    dispatch(setActiveSection(combinedSections[0]));
  }
}, [questionsData, combinedSections, activeSection, dispatch]);

  const handleSectionClick = (sec) => {
    dispatch(setActiveSection(sec));

    const firstQuestion = questionsData?.find(
      (q) => getExamSectionKey(q) === sec
    );

    if (firstQuestion) {
      const firstIndex = questionsData.findIndex(
        (q) => q.qid === firstQuestion.qid
      );

      dispatch(setCurrentQuestionIndex(firstIndex));
      dispatch(
        fetchExamQuestionRequest({
          paperId: paperId,
          paperType: testDetails?.paper_type,
          qid: firstQuestion?.qid,
          testId: testDetails?.testId,
        })
      );
    }
  };

  return (
    <div className="section-tabs-wrapper">
      <div className="section-tabs">
        <div className="tabs-left">
          {combinedSections.map((sec) => (
            <div
              key={sec}
              className={`tab-item ${activeSection === sec ? "active" : ""}`}
              onClick={() => handleSectionClick(sec)}
            >
              {sec}
            </div>
          ))}
        </div>

        {/* {!isSidebarOpen && (
          <div className="tabs-right">
            <span className="view-all" onClick={() => setIsSidebarOpen(true)}>
              View all Q’s ⇒
            </span>
          </div>
        )} */}
      </div>

      {!isAdaptiveMode ? (
      <Sidebar
        // isOpen={isSidebarOpen}
        // onClose={() => setIsSidebarOpen(false)}
        width={`${sidebarWidth}px`}
        position="right"
        color="#000"
        padding="20px"
        boxShadow="-2px 0px 8px rgba(0,0,0,0.15)"
        offsetTop={90}
        // showOverlay={false}
        // CloseButton={
        //   <img
        //     src={images.menuClose}
        //     alt="close"
        //     style={{ width: 24, cursor: "pointer" }}
        //   />
        // }
      >
        <QuestionLegend />
        <QuestionGrid
          onSelect={handleSelectQuestionInternal}
          registerRef={(sec, el) => {
            if (!questionRefs.current[sec]) {
              questionRefs.current[sec] = el;
            }
          }}
        />
      </Sidebar>
      ) : null}
    </div>
  );
}
